import DashboardIncidentsMainMechanism from './DashboardIncidentsMainMechanism';

export default DashboardIncidentsMainMechanism;
